var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.93934 19.0607C0.353553 18.4749 0.353553 17.5251 0.93934 16.9393L7.87868 10L0.939339 3.06066C0.353553 2.47487 0.353553 1.52513 0.939339 0.939341C1.52513 0.353554 2.47487 0.353554 3.06066 0.93934L12.1213 10L3.06066 19.0607C2.47487 19.6464 1.52513 19.6464 0.93934 19.0607Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIcon);
export default __webpack_public_path__ + "static/media/arrowForwardIcon.46cce0b77bdb8f9ce6edb223324f9df0.svg";
export { ForwardRef as ReactComponent };